// extracted by mini-css-extract-plugin
module.exports = {"offlineContent":"Offline_offlineContent__dLVqP","image":"Offline_image__2lKO4"};